module.exports = __webpack_public_path__ + "static/media/marie.fae0eba4.jpg";